// extracted by mini-css-extract-plugin
export default {"editMode":"ContentTypeQREdit_editMode__fqTof","wrapper":"ContentTypeQREdit_wrapper__lM8n6"};